import { SiTrackPage } from '../../../components/si-track-page';
import { SaveCustomerComponent } from './save-customer.component';

export const CreateCustomerPage = () => {
  const defaultCustomer: any = {};

  return (
    <SiTrackPage title="Create Customer">
      <SaveCustomerComponent customer={defaultCustomer} />
    </SiTrackPage>
  );
};
